// Environment accessor that works in both Vite (web) and RN (via a shim).
// For Vite: Vite performs STATIC replacement of `import.meta.env.VITE_*`
// at build time. That replacement only fires on literal property-access
// syntax — indirections like `const e = import.meta.env; e.VITE_X`
// silently fall back to undefined in the built bundle. So every read below
// must spell out `import.meta.env.VITE_FOO` directly.
// For RN: Metro replaces this module with a native shim that never
// evaluates the Vite-only code path.
type Env = {
  API_URL: string;
  API_PREFIX: string;
  SENTRY_DSN?: string;
  LOG_LEVEL: string;
};

function fromVite(): Env | null {
  try {
    // `import.meta.env` itself is undefined in non-Vite environments; the
    // optional chain + try/catch keeps RN from crashing at module init.
    // The property-access form below is what Vite actually rewrites.
    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    // @ts-ignore — import.meta.env is only typed inside Vite projects.
    const apiUrl: string | undefined = import.meta.env?.VITE_API_URL;
    if (apiUrl == null) return null;
    return {
      API_URL: apiUrl,
      // @ts-ignore
      API_PREFIX: import.meta.env?.VITE_API_PREFIX ?? '/v1',
      // @ts-ignore
      SENTRY_DSN: import.meta.env?.VITE_SENTRY_DSN,
      // @ts-ignore
      LOG_LEVEL: import.meta.env?.VITE_LOG_LEVEL ?? 'info',
    };
  } catch {
    return null;
  }
}

export const env: Env = fromVite() ?? {
  API_URL: 'http://localhost:3000',
  API_PREFIX: '/v1',
  LOG_LEVEL: 'info',
};

export function apiUrl(path: string) {
  const base = env.API_URL.replace(/\/+$/, '');
  const prefix = env.API_PREFIX.startsWith('/') ? env.API_PREFIX : `/${env.API_PREFIX}`;
  const suffix = path.startsWith('/') ? path : `/${path}`;
  return `${base}${prefix}${suffix}`;
}
